// extracted by mini-css-extract-plugin
export default {"wrapper":"component_wrapper__tWcE9","container":"component_container__SJUKZ"};